<script>
  import {API_VILLAGE} from '../common/api'
  import {getFirstNode, rangeVillage} from '../assets/js/funcs'

  export default {
    name: 'VillageSelect',
    props: ["defaultVillageId"],
    data() {
      return {
        villageList: [],
        optionProps: {
          value: 'id',
          label: 'name',
          expandTrigger: 'hover',
          checkStrictly: true     // 可以选择任意一级选项
        },
        selectedVillage: []
      }
    },
    watch: {
      defaultVillageId(val) {
        if (val === 0) {
          this.selectedVillage = [];
        } else {
          let villageListTemp = this.$store.state.village.villageList;
          let village = villageListTemp.find(item => item.id === val);
          if (village !== undefined) {
            this.selectedVillage = village.code.split(',').map(Number)
          }
        }
      }
    },
    created() {
      this.villageList = this.$store.state.village.arrangeVillageList
    },
    methods: {
      handleChange(value) {
        if (this.$refs['villageSelectCascade']) {
          this.$refs['villageSelectCascade'].dropDownVisible = false;
        }
        this.$emit('selectVillageId', value[value.length - 1]);
      },
    }
  }
</script>

<template>
  <el-cascader
    ref="villageSelectCascade"
    :options="villageList"
    v-model="selectedVillage"
    @change="handleChange"
    placeholder="请选择小区"
    size="small"
    :props="optionProps"
    :show-all-levels="false"
    style="width: 220px;"
    clearable
    >
    <template slot-scope="{ node, data }">
      <span>{{ data.name }}</span>
      <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
    </template>
  </el-cascader>
</template>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/VillageSelect.vue